<template>
  <el-select
    ref="ElSelect"
    :clearable="clearable"
    :filterable="filterable"
    :value="selectValue"
    :filter-method="handleFilterMethod"
    @visible-change="handleVisibleChange"
    @clear="handleClear"
  >
    <el-option class="select-dropdown__item" value disabled>
      <el-tree
        class="select-tree"
        ref="ElTree"
        :node-key="nodeKey"
        :data="data"
        :props="elTreeProps"
        :expand-on-click-node="false"
        :filter-node-method="handleFilterNode"
        @node-click="handleNodeClick"
      ></el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'SelectTree',
  props: {
    value: String,
    data: Array,
    clearable: Boolean,
    filterable: Boolean,
    fieldNames: {
      type: Object,
      default() {
        return {
          id: 'id',
          label: 'label',
          children: 'children',
          key: 'key'
        }
      }
    },
    nodeKey: {
      type: String,
      default: 'key'
    }
  },
  data() {
    return {
      selectValue: undefined
    }
  },
  computed: {
    elTreeProps() {
      const { label, children } = this.fieldNames
      return {
        label,
        children
      }
    }
  },
  methods: {
    handleFilterNode(value, data) {
      if (!value) return true
      return data[this.fieldNames.label].indexOf(value) !== -1
    },
    handleFilterMethod(value) {
      this.$nextTick(() => {
        this.$refs.ElTree.filter(value)
      })
    },
    handleVisibleChange(visibled) {
      if (this.filterable && visibled) {
        this.handleFilterMethod(this.selectValue)
      }
    },
    handleClear() {
      this.selectValue = undefined
      this.$refs.ElTree.setCurrentKey(null)
      this.$emit('input', undefined)
    },
    handleNodeClick(data) {
      this.selectValue = data[this.fieldNames.label]
      this.$emit('input', data[this.nodeKey])
      this.$refs.ElSelect.blur()
    }
  }
}
</script>

<style scoped lang="scss">
.select-dropdown__item {
  height: auto !important;
  padding: 0 !important;
}

.select-tree /deep/ .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 600;
}

.select-tree /deep/ .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
</style>
